import React from 'react';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import ManagerFields from '../ContractorCreateUpdateFlows/ManagerFields';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { STEPS_CONTRACTOR_EMPLOYEE_UPDATE_NO_DETAILS } from '../../Model/Models';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const ContractorEmployeeUpdateWithoutDetails = ({
    user,
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    emptyFields,
    setUser,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePasswordChange,
    handlePhoneNumberChange,
    handleDateChange,
    userInfoStatusList,
    photoPicker,
    setPhotoPicker,
}) => {
    return (
        <StepperTabs
            id={user?.id}
            steps={steps}
            activeStep={activeStep}
            isStepOptional={() => {}}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab
                index={STEPS_CONTRACTOR_EMPLOYEE_UPDATE_NO_DETAILS.MANAGER_DETAILS}
                activeStep={activeStep}
                normalHeight
            >
                <ManagerFields
                    title={'user_data'}
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    statusList={userInfoStatusList}
                />
            </StepTab>

            <StepTab index={STEPS_CONTRACTOR_EMPLOYEE_UPDATE_NO_DETAILS.ADD_PHOTO} activeStep={activeStep} normalHeight>
                <CustomPhotoPicker
                    id='fp_ceuwd_update_photo_profile'
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    actionModel={ACTION_MODEL.UPDATE}
                    accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                    showBtnCamera
                    validateFace
                    classWith={'w-400px'}
                    showPreview
                    titleModalEdit='update_photography'
                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                />
            </StepTab>
        </StepperTabs>
    );
};
export default ContractorEmployeeUpdateWithoutDetails;
